import {CachingCollection} from "../../../collections/_BaseCollection";

export class BaseVMeterCollection<TModel extends Backbone.Model> extends CachingCollection<TModel> {
    appUrlRoot = 'vmeter';
}


// WEBPACK FOOTER //
// ./srv/public/js/apps/vmeter/collections/_BaseVMeterCollection.ts